import React from 'react';
import './bookings.css';
import { GoogleMap, Marker } from '@react-google-maps/api';
import { useHistory } from 'react-router-dom';
import {
    businessAverageRating,
    convertTo12HourFormat,
} from '../../helpers/constants';
import { toast } from 'react-toastify';
import { isAuthenticated } from '../../helpers/functions';
import { useSelector } from 'react-redux';

const BookingMap = ({ businessDetails, hide }) => {
    const history = useHistory();
    const { userData } = useSelector((state) => state.user);

    const mapStyles = {
        width: '100%',
        height: '122px',
        borderRadius: '10px',
    };

    const center = {
        lat: parseFloat(businessDetails?.latitude),
        lng: parseFloat(businessDetails?.longitude),
    };

    const customMapOptions = {
        gestureHandling: 'none', // Disables pan and zoom gestures
        zoomControl: true, // Hides the default zoom control
    };
    console.log(businessDetails);
    return (
        <div className="p-4 booking-map-section">
            <p className="m-0 c-0f151d fs-16 fw-600 poppins">
                {businessDetails?.name}
            </p>
            <p className="m-0 c-667085 fs-16 mt-1 poppins">
                {businessDetails?.address}
            </p>
            <div className="d-flex align-items-center justify-content-between gap-2 mt-2">
                <div className="d-flex align-items-center justify-content-start">
                    <h6 className={`m-0 c-0f151d poppins f-16 fw-normal lh-16`}>
                        {businessAverageRating(businessDetails?.reviews || [])}
                    </h6>
                    <svg
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="mx-1"
                    >
                        <g clipPath="url(#clip0_252_296)">
                            <path
                                d="M2.44884 11.6623C2.40084 11.6623 2.35284 11.6383 2.30484 11.6143C2.23284 11.5663 2.18484 11.4463 2.20884 11.3503L3.26484 7.41428L0.0968438 4.84628C0.000843818 4.79828 -0.0231562 4.67828 0.000843815 4.58228C0.0248438 4.48628 0.120844 4.41428 0.216844 4.41428L4.29684 4.19828L5.76084 0.382281C5.80884 0.310281 5.90484 0.238281 6.00084 0.238281C6.09684 0.238281 6.19284 0.310281 6.21684 0.382281L7.68084 4.19828L11.7608 4.41428C11.8568 4.41428 11.9528 4.48628 11.9768 4.58228C12.0008 4.67828 11.9768 4.77428 11.9048 4.84628L8.73684 7.41428L9.79284 11.3503C9.81684 11.4463 9.79284 11.5423 9.69684 11.6143C9.62484 11.6623 9.50484 11.6863 9.43284 11.6143L6.00084 9.40628L2.56884 11.6143C2.52084 11.6623 2.49684 11.6623 2.44884 11.6623Z"
                                fill="#334155"
                            />
                        </g>
                        <defs>
                            <clipPath id="clip0_252_296">
                                <rect width="12" height="12" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                    <h6
                        className={`m-0  c-0f151d poppins f-16 fw-normal lh-16`}
                    >
                        ({businessDetails?.reviews?.length || 0})
                    </h6>
                </div>
                <div className="d-flex gap-2">
                    {businessDetails?.website && (
                        <a href={businessDetails?.website} target="_blank">
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M10 1.875C8.39303 1.875 6.82214 2.35152 5.486 3.24431C4.14985 4.1371 3.10844 5.40605 2.49348 6.8907C1.87852 8.37535 1.71762 10.009 2.03112 11.5851C2.34463 13.1612 3.11846 14.6089 4.25476 15.7452C5.39106 16.8815 6.8388 17.6554 8.4149 17.9689C9.99099 18.2824 11.6247 18.1215 13.1093 17.5065C14.594 16.8916 15.8629 15.8502 16.7557 14.514C17.6485 13.1779 18.125 11.607 18.125 10C18.1227 7.84581 17.266 5.78051 15.7427 4.25727C14.2195 2.73403 12.1542 1.87727 10 1.875ZM16.8461 9.375H13.7344C13.6242 7.15156 12.932 5.04141 11.7719 3.35938C13.1306 3.72417 14.3452 4.49613 15.2523 5.57152C16.1594 6.64691 16.7156 7.97419 16.8461 9.375ZM10 16.8664C8.53672 15.2828 7.64922 13.0383 7.51797 10.625H12.482C12.3508 13.0367 11.4633 15.2828 10 16.8664ZM7.51797 9.375C7.64922 6.96328 8.5336 4.71719 10 3.13359C11.4633 4.71719 12.3508 6.96172 12.482 9.375H7.51797ZM8.22813 3.35938C7.06797 5.04141 6.37578 7.15156 6.26563 9.375H3.15391C3.28444 7.97419 3.84063 6.64691 4.74773 5.57152C5.65483 4.49613 6.86937 3.72417 8.22813 3.35938ZM3.15391 10.625H6.26563C6.37578 12.8484 7.06797 14.9586 8.22813 16.6406C6.86937 16.2758 5.65483 15.5039 4.74773 14.4285C3.84063 13.3531 3.28444 12.0258 3.15391 10.625ZM11.7719 16.6406C12.932 14.9563 13.6242 12.8461 13.7344 10.625H16.8461C16.7156 12.0258 16.1594 13.3531 15.2523 14.4285C14.3452 15.5039 13.1306 16.2758 11.7719 16.6406Z"
                                    fill="#667085"
                                />
                            </svg>
                        </a>
                    )}
                    {businessDetails?.facebook && (
                        <a href={businessDetails?.facebook} target="_blank">
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M10 1.875C8.39303 1.875 6.82214 2.35152 5.486 3.24431C4.14985 4.1371 3.10844 5.40605 2.49348 6.8907C1.87852 8.37535 1.71762 10.009 2.03112 11.5851C2.34463 13.1612 3.11846 14.6089 4.25476 15.7452C5.39106 16.8815 6.8388 17.6554 8.4149 17.9689C9.99099 18.2824 11.6247 18.1215 13.1093 17.5065C14.594 16.8916 15.8629 15.8502 16.7557 14.514C17.6485 13.1779 18.125 11.607 18.125 10C18.1227 7.84581 17.266 5.78051 15.7427 4.25727C14.2195 2.73403 12.1542 1.87727 10 1.875ZM10.625 16.8461V11.875H12.5C12.6658 11.875 12.8247 11.8092 12.9419 11.6919C13.0592 11.5747 13.125 11.4158 13.125 11.25C13.125 11.0842 13.0592 10.9253 12.9419 10.8081C12.8247 10.6908 12.6658 10.625 12.5 10.625H10.625V8.75C10.625 8.41848 10.7567 8.10054 10.9911 7.86612C11.2255 7.6317 11.5435 7.5 11.875 7.5H13.125C13.2908 7.5 13.4497 7.43415 13.5669 7.31694C13.6842 7.19973 13.75 7.04076 13.75 6.875C13.75 6.70924 13.6842 6.55027 13.5669 6.43306C13.4497 6.31585 13.2908 6.25 13.125 6.25H11.875C11.212 6.25 10.5761 6.51339 10.1072 6.98223C9.6384 7.45107 9.375 8.08696 9.375 8.75V10.625H7.5C7.33424 10.625 7.17527 10.6908 7.05806 10.8081C6.94085 10.9253 6.875 11.0842 6.875 11.25C6.875 11.4158 6.94085 11.5747 7.05806 11.6919C7.17527 11.8092 7.33424 11.875 7.5 11.875H9.375V16.8461C7.61312 16.6853 5.98107 15.8514 4.81831 14.5179C3.65556 13.1845 3.05162 11.4541 3.13212 9.68674C3.21263 7.91936 3.97137 6.25106 5.25053 5.02883C6.52969 3.80661 8.2308 3.12456 10 3.12456C11.7692 3.12456 13.4703 3.80661 14.7495 5.02883C16.0286 6.25106 16.7874 7.91936 16.8679 9.68674C16.9484 11.4541 16.3444 13.1845 15.1817 14.5179C14.0189 15.8514 12.3869 16.6853 10.625 16.8461Z"
                                    fill="#667085"
                                />
                            </svg>
                        </a>
                    )}
                    {businessDetails?.Instagram && (
                        <a href={businessDetails?.Instagram} target="_blank">
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M10 6.25C9.25832 6.25 8.5333 6.46993 7.91661 6.88199C7.29993 7.29404 6.81928 7.87971 6.53545 8.56494C6.25162 9.25016 6.17736 10.0042 6.32206 10.7316C6.46675 11.459 6.8239 12.1272 7.34835 12.6517C7.8728 13.1761 8.54098 13.5333 9.26841 13.6779C9.99584 13.8226 10.7498 13.7484 11.4351 13.4645C12.1203 13.1807 12.706 12.7001 13.118 12.0834C13.5301 11.4667 13.75 10.7417 13.75 10C13.749 9.00576 13.3535 8.05253 12.6505 7.34949C11.9475 6.64645 10.9942 6.25103 10 6.25ZM10 12.5C9.50555 12.5 9.0222 12.3534 8.61107 12.0787C8.19995 11.804 7.87952 11.4135 7.6903 10.9567C7.50108 10.4999 7.45157 9.99723 7.54804 9.51227C7.6445 9.02732 7.8826 8.58186 8.23223 8.23223C8.58186 7.8826 9.02732 7.6445 9.51227 7.54804C9.99723 7.45157 10.4999 7.50108 10.9567 7.6903C11.4135 7.87952 11.804 8.19995 12.0787 8.61107C12.3534 9.0222 12.5 9.50555 12.5 10C12.5 10.663 12.2366 11.2989 11.7678 11.7678C11.2989 12.2366 10.663 12.5 10 12.5ZM13.75 1.875H6.25C5.09006 1.87624 3.97798 2.33758 3.15778 3.15778C2.33758 3.97798 1.87624 5.09006 1.875 6.25V13.75C1.87624 14.9099 2.33758 16.022 3.15778 16.8422C3.97798 17.6624 5.09006 18.1238 6.25 18.125H13.75C14.9099 18.1238 16.022 17.6624 16.8422 16.8422C17.6624 16.022 18.1238 14.9099 18.125 13.75V6.25C18.1238 5.09006 17.6624 3.97798 16.8422 3.15778C16.022 2.33758 14.9099 1.87624 13.75 1.875ZM16.875 13.75C16.875 14.5788 16.5458 15.3737 15.9597 15.9597C15.3737 16.5458 14.5788 16.875 13.75 16.875H6.25C5.4212 16.875 4.62634 16.5458 4.04029 15.9597C3.45424 15.3737 3.125 14.5788 3.125 13.75V6.25C3.125 5.4212 3.45424 4.62634 4.04029 4.04029C4.62634 3.45424 5.4212 3.125 6.25 3.125H13.75C14.5788 3.125 15.3737 3.45424 15.9597 4.04029C16.5458 4.62634 16.875 5.4212 16.875 6.25V13.75ZM15 5.9375C15 6.12292 14.945 6.30418 14.842 6.45835C14.739 6.61252 14.5926 6.73268 14.4213 6.80364C14.25 6.87459 14.0615 6.89316 13.8796 6.85699C13.6977 6.82081 13.5307 6.73152 13.3996 6.60041C13.2685 6.4693 13.1792 6.30225 13.143 6.1204C13.1068 5.93854 13.1254 5.75004 13.1964 5.57873C13.2673 5.40743 13.3875 5.26101 13.5417 5.158C13.6958 5.05498 13.8771 5 14.0625 5C14.3111 5 14.5496 5.09877 14.7254 5.27459C14.9012 5.4504 15 5.68886 15 5.9375Z"
                                    fill="#667085"
                                />
                            </svg>
                        </a>
                    )}
                </div>
            </div>
            <div className="my-3">
                <GoogleMap
                    mapContainerStyle={mapStyles}
                    zoom={12}
                    center={center}
                    options={{ ...customMapOptions }}
                >
                    <Marker position={center} />
                </GoogleMap>
            </div>
            <p className="c-0f151d fs-16 fw-600 mb-2 poppins">Opening times</p>
            {businessDetails?.openingTimes &&
                Object.entries(businessDetails?.openingTimes)?.map(
                    ([key, value], index) => (
                        <div
                            className="d-flex justify-content-between c-0f151d f-12 fw-medium mt-2 poppins"
                            key={index}
                        >
                            <p className="m-0">{key}</p>{' '}
                            <p className="m-0">
                                {value?.isOpened === 'true'
                                    ? `${convertTo12HourFormat(
                                          value?.from
                                      )} - ${convertTo12HourFormat(value?.to)}`
                                    : 'Closed'}
                            </p>
                        </div>
                    )
                )}

            {Array.isArray(businessDetails?.categories) &&
                businessDetails?.categories.length > 0 && (
                    <button
                        type="button"
                        className="text-white w-100 booking-btn f-16 mt-3 poppins"
                        onClick={() => {
                            if (
                                isAuthenticated() &&
                                userData?.role === 'business'
                            ) {
                                toast.error(
                                    'To book an appointment, you need to create a customer account first.'
                                );
                            } else {
                                history.push(
                                    `/${
                                        hide ? 'stylist' : 'business-details'
                                    }/${
                                        hide
                                            ? businessDetails?.name
                                            : businessDetails?.id
                                    }/services`
                                );
                            }
                        }}
                    >
                        Book Now
                    </button>
                )}
        </div>
    );
};

export default BookingMap;
